import { type PropsWithChildren, useState } from 'react'

import { Provider } from './showChangesButtonContext'

type Props = PropsWithChildren

/**
 * Context Provider for telling if the "Review Changes" button should be visible in a form.
 */
const ShowChangesButtonProvider = ({ children }: Props) => {
  const [shouldShowReviewButton, setShouldShowReviewButton] =
    useState<boolean>(false)

  return (
    <Provider
      value={{
        shouldBeVisible: shouldShowReviewButton,
        onChangeVisibility: setShouldShowReviewButton,
      }}
    >
      {children}
    </Provider>
  )
}

export { ShowChangesButtonProvider }
